import { gameName } from './gameConfigsAndUrls';

export const RoutePaths = {
  game: `/${gameName}/game`,
  replay: `/${gameName}/replay`,
};
